export default __webpack_public_path__ + "static/media/right-side-wheel.4a757d61.png";